import { render, staticRenderFns } from "./MerchantUserManage.vue?vue&type=template&id=4fab8783"
import script from "./MerchantUserManage.vue?vue&type=script&lang=js"
export * from "./MerchantUserManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports